/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import 'aisztheme';
import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import CSSModules from 'react-css-modules';
import SideBar from 'loracoms/SideBar';
import SidebarContainer from 'loracoms/SidebarContainer';
import IntlMsg from 'lorautils/intl/IntlMsg';
import { callAPI } from 'lorautils/api';
import DetailView from './coms/DetailView';
import ParserView from './coms/ParserView';
import {
  transform,
  loadParserWithApp,
} from './func/parser';
import { getUrl, getHttpUrl } from './func/url';
import styles from './styles.scss';


function getType(url) {
  const type = url.split(':')[0];
  if (type === 'wss') {
    return 'ws';
  }
  if (type === 'https') {
    return 'http';
  }
  return type;
}

const propTypes = {
  intl: React.PropTypes.any.isRequired,
  appId: React.PropTypes.string.isRequired,
};

class AppDebug extends React.Component {
  constructor(props) {
    super(props);
    this.type = '';
    this.url = getUrl() || '';
    this.type = getType(this.url) || '';
    this.httpUrl = getHttpUrl() || '';
    this.parser = loadParserWithApp(props.appId);
    this.state = {
      view: 'detail',
      data: [],
      feedback: null,
      wsStatus: '',
    };
    this.intlMsg = new IntlMsg(props.intl, 'appdebug');
  }


  componentDidMount() {
    this.mounted = true;
    if (this.type === 'ws') {
      this.connectToWebSocket();
      callAPI({
        endpoint: this.httpUrl,
        query: {
          limit: 1,
        },
      }).then(data => this.setState({
        data: transform(this.parser, data.list).map(item => ({
          ...item,
          frequency: item.frequency / 1000000,
          lorasnr: item.lorasnr.toFixed(1),
        })),
      }));
    } else {
      const fetchData = () => {
        callAPI({
          endpoint: this.httpUrl,
          query: {
            limit: 20,
          },
        }).then(data => this.setState({
          data: transform(this.parser, data.list).map(item => ({
            ...item,
            frequency: item.frequency / 1000000,
            lorasnr: item.lorasnr.toFixed(1),
          })),
        }));
      };
      this.intervalId = setInterval(fetchData, 10000);
      fetchData();
    }
  }

  componentWillUnmount() {
    this.mounted = false;
    if (this.wsSocket) {
      this.wsSocket.close();
      this.wsSocket = null;
    }
    if (this.connectTimeout) {
      window.clearTimeout(this.connectTimeout);
      this.connectTimeout = null;
    }
    if (this.intervalId) {
      window.clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  connectToWebSocket() {
    this.wsSocket = new WebSocket(`${this.url}&feedback`);
    this.wsSocket.onopen = () => {
      this.setState({ wsStatus: 'connected' });
    };
    this.wsSocket.onmessage = (event) => {
      this.handleEvent(event);
    };
    this.wsSocket.onclose = () => {
      if (this.mounted) {
        this.setState({ wsStatus: 'closed' });
        // reconnect after 2 seconds
        this.connectTimeout = window.setTimeout(() => {
          this.setState({ wsStatus: 'reconnecting' });
          this.connectToWebSocket();
        }, 2000);
      }
    };
  }

  handleEvent(event) {
    const evtData = JSON.parse(event.data);
    if (evtData.feedback) {
      this.setState({ feedback: evtData });
    } else {
      let data = this.state.data;
      const payload = JSON.parse(evtData.payload);
      payload.frequency /= 1000000;
      payload.lorasnr = payload.lorasnr.toFixed(1);
      data = [{ ...payload, $time: Date.now() }].concat(data);
      data = transform(this.parser, data);
      this.setState({ data });
    }
  }

  handleParserChange(parser) {
    this.parser = parser;
    const data = transform(parser, this.state.data);
    this.setState({ data });
  }

  renderSideBar() {
    const { view = 'detail' } = this.state;
    return (
      <SideBar
        height={window.innerHeight}
        title={this.intlMsg.msg('sidebar.title')}
        menuItems={[{
          icon: <span className="glyphicons glyphicons-blackboard" />,
          text: this.intlMsg.msg('sidebar.detail'),
          onClick: () => this.setState({ view: 'detail' }),
          active: view === 'detail',
        }, {
          icon: <span className="glyphicons glyphicons-stethoscope" />,
          text: this.intlMsg.msg('sidebar.parsedata'),
          onClick: () => this.setState({ view: 'parser' }),
          active: view === 'parser',
        }]}
      />
    );
  }

  renderView() {
    const { appId } = this.props;
    const { data = [], view = 'detail', wsStatus, feedback } = this.state;
    if (view === 'detail') {
      return (
        <DetailView
          data={data}
          appId={appId}
          url={this.url}
          wsType={this.type}
          wsSocket={this.wsSocket}
          wsStatus={wsStatus}
          wsFeedback={feedback}
          resetFeedback={() => { this.setState({ feedback: null }); }}
        />
      );
    } else if (view === 'parser') {
      return (
        <ParserView
          data={data}
          wsType={this.type}
          appId={appId}
          wsStatus={wsStatus}
          onSaveParser={(parser) => { this.handleParserChange(parser); }}
        />
      );
    }
    return null;
  }

  render() {
    return (
      <div>
        {this.renderSideBar()}
        <SidebarContainer>
          <div className={styles.view}>
            {this.renderView()}
          </div>
        </SidebarContainer>
      </div>
    );
  }
}

AppDebug.propTypes = propTypes;

const mapStateToProps = (state, ownProps) => ({
  appId: ownProps.params.id,
});

export default connect(
  mapStateToProps,
  null,
)(injectIntl(CSSModules(AppDebug, styles, { allowMultiple: true })));




// WEBPACK FOOTER //
// ./src/containers/Application/coms/ApplicationDetail/coms/APIView/coms/AppDebug/index.jsx